module.exports = __webpack_public_path__ + "static/media/Francis Mumbi.11a6891a.jpg";